import FetchService from "./Shared/FetchService";
import SchedulerCourseSectionService from "../Domain/SchedulerCourseSection/SchedulerCourseSection.service";
const selectedCourseSectionsURL = "/aviso/courseSectionSchedulerSelectedCourseSection";
export default class CourseSectionSchedulerCourseSectionService {
    static getSelectedCourseSections(termId) {
        return FetchService.getSingleResponse(selectedCourseSectionsURL + "/getSelectedCourseSections", { termId }).then((secs) => 
        // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'sec' implicitly has an 'any' type.
        secs.map((sec) => SchedulerCourseSectionService.fromJson(sec)));
    }
    static selectCourseSection(termId, courseSectionId) {
        return FetchService.postSingleResponse(selectedCourseSectionsURL + "/selectCourseSection", { termId, courseSectionId });
    }
    static unselectCourseSection(termId, courseSectionId) {
        return FetchService.postSingleResponse(selectedCourseSectionsURL + "/unselectCourseSection", { termId, courseSectionId });
    }
}
